import {
  addZeroEntriesForMissingDates,
  removeTimezoneFromDateString,
} from '@fourthwall/module-analytics'

import type { AnalyticsParams } from '../../../../../modules/AnalyticsParams'

export const mapCurrentProfitDataToChartSeriesData = (
  currentProfitData: { timestamps: string[]; values: number[] } | undefined,
  params: AnalyticsParams,
) => {
  if (!currentProfitData) return []

  const { timestamps, values } = addZeroEntriesForMissingDates(currentProfitData, params)

  return timestamps.map((value, index) => ({
    date: new Date(removeTimezoneFromDateString(value)),
    value: values[index],
  }))
}
